import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";

import Header from "../components/Header";
import Footer from "../components/Footer";
import "./index.css";

import "./global-styles";

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="Jurek Barth"
      meta={[
        {
          name: "description",
          content: `I'm a software engineer living in Munich.`
        },
        { name: "keywords", content: "developer, software engineer" }
      ]}
    />
    <Header />
    <div>{children()}</div>
    <Footer />
  </div>
);

TemplateWrapper.propTypes = {
  children: PropTypes.func
};

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js